import { Link } from "react-router-dom";

const LAST_UPDATED = "February 12, 2026";

const Section = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="kicker text-[hsl(var(--accent))]">{title}</h2>
    <div className="mt-3 text-[hsl(var(--ink-soft))] leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function Terms() {
  return (
    <div className="pt-32">
      <section className="mx-auto max-w-3xl px-6 md:px-10 py-16">
        <div className="kicker">Terms of Service</div>
        <h1 className="font-display text-4xl md:text-6xl leading-[1.05] mt-6">
          The rules of the road for using our <span className="italic">website</span>.
        </h1>
        <p className="mt-4 text-sm text-[hsl(var(--ink-soft))]">Last updated: {LAST_UPDATED}</p>

        <Section title="Agreement">
          <p>
            These Terms of Service ("Terms") govern your use of the website <strong>shobhawithshubhra.com</strong>
            {" "}(the "Site") operated by <strong>Shobha with Shubhra LLC</strong> ("we", "us", "our"),
            a Wisconsin, USA limited liability company. By using the Site you agree to these Terms. If you do not
            agree, please do not use the Site.
          </p>
        </Section>

        <Section title="Nature of the Site">
          <p>
            The Site is a marketing and enquiry channel for our wedding and event planning services. Content on the
            Site — including images, portfolio examples, journal articles and testimonials — is provided for
            informational purposes only. Nothing on the Site is a binding offer or price quotation. Any project
            engagement is subject to a separate written services agreement signed by both parties.
          </p>
        </Section>

        <Section title="Contact form &amp; consultation requests">
          <p>
            Submitting the contact form or requesting a consultation via the chat widget does not create a
            business relationship or obligate us to provide services. We will respond to enquiries on a best-effort
            basis and may decline to work with any prospective client at our sole discretion.
          </p>
        </Section>

        <Section title="AI assistant (Ayaan)">
          <p>
            Our chat widget is powered by an AI assistant named <strong>Ayaan</strong>. Responses are generated by
            a large-language model and may occasionally be inaccurate or incomplete. Anything discussed with Ayaan
            is informational only and does not constitute a quote, promise, or contract. Please confirm anything
            important directly with Shubhra during a consultation.
          </p>
        </Section>

        <Section title="Cookies &amp; tracking technologies">
          <p>
            The Site uses strictly-necessary cookies to function and, only with your consent,
            analytics cookies to help us understand how visitors use the Site. By clicking
            "Accept all" in the cookie banner you agree to the placement of these cookies. By
            clicking "Reject non-essential" you allow only cookies required for the Site to
            work. You may withdraw or change your choice at any time from our{" "}
            <Link to="/cookie-policy" className="text-[hsl(var(--accent))] underline">
              Cookie Policy
            </Link>
            . For details of what we store, how long, and the legal basis we rely on, see the{" "}
            <Link to="/privacy" className="text-[hsl(var(--accent))] underline">
              Privacy Policy
            </Link>
            . We do not use advertising cookies, cross-site trackers, or "sell" personal
            information as defined by the CCPA/CPRA.
          </p>
        </Section>

        <Section title="Cookies &amp; tracking technologies">
          <p>
            The Site uses strictly-necessary cookies to function and, only with your consent,
            analytics cookies to help us understand how visitors use the Site. By clicking
            "Accept all" in the cookie banner you agree to the placement of these cookies. By
            clicking "Reject non-essential" you allow only cookies required for the Site to
            work. You may withdraw or change your choice at any time from our{" "}
            <Link to="/cookie-policy" className="text-[hsl(var(--accent))] underline">
              Cookie Policy
            </Link>
            . For details of what we store, how long, and the legal basis we rely on, see the{" "}
            <Link to="/privacy" className="text-[hsl(var(--accent))] underline">
              Privacy Policy
            </Link>
            . We do not use advertising cookies, cross-site trackers, or "sell" personal
            information as defined by the CCPA/CPRA.
          </p>
        </Section>

        <Section title="Intellectual property">
          <p>
            All text, images, graphics, logos, layout and other content on the Site are owned by Shobha with
            Shubhra LLC or its licensors, and are protected under United States copyright and trademark law. You
            may not copy, reproduce, distribute, modify or create derivative works from any Site content without
            our prior written permission, except that you may share individual pages for personal, non-commercial
            purposes with attribution.
          </p>
          <p>
            "Shobha with Shubhra" and the associated logo are trademarks of Shobha with Shubhra LLC.
          </p>
        </Section>

        <Section title="Client photos &amp; testimonials">
          <p>
            Portfolio images and testimonials are published with the consent of the featured clients. If you are
            featured on the Site and would like your image or testimonial removed, please email{" "}
            <a className="text-[hsl(var(--accent))] underline" href="mailto:contact@shobhawithshubhra.com">
              contact@shobhawithshubhra.com
            </a>{" "}
            and we will action your request promptly.
          </p>
        </Section>

        <Section title="Prohibited uses">
          <p>You agree not to:</p>
          <ul className="list-disc list-outside pl-5 space-y-2">
            <li>Use the Site or the chat assistant for any unlawful purpose or to harass any person.</li>
            <li>Attempt to gain unauthorized access to any part of the Site, our systems or other users' data.</li>
            <li>Scrape, mine, or systematically collect content from the Site for commercial purposes.</li>
            <li>Submit spam, false enquiries, or automated form submissions.</li>
            <li>Impersonate any person or misrepresent your identity or affiliation.</li>
          </ul>
        </Section>

        <Section title="Disclaimer of warranties">
          <p>
            THE SITE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE, OR NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE SITE WILL BE UNINTERRUPTED, SECURE, OR
            ERROR-FREE.
          </p>
        </Section>

        <Section title="Limitation of liability">
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, SHOBHA WITH SHUBHRA LLC AND ITS OWNERS, EMPLOYEES AND AGENTS
            SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES ARISING
            OUT OF YOUR USE OF THE SITE. OUR TOTAL AGGREGATE LIABILITY FOR ANY CLAIM RELATING TO THE SITE SHALL
            NOT EXCEED ONE HUNDRED U.S. DOLLARS (USD 100).
          </p>
        </Section>

        <Section title="Indemnification">
          <p>
            You agree to indemnify and hold Shobha with Shubhra LLC harmless from any claims, damages, losses,
            liabilities and expenses (including reasonable attorneys' fees) arising out of your breach of these
            Terms or your misuse of the Site.
          </p>
        </Section>

        <Section title="Governing law &amp; venue">
          <p>
            These Terms are governed by the laws of the State of Wisconsin, USA, without regard to its conflict
            of laws principles. Any dispute arising out of or relating to the Site or these Terms shall be brought
            exclusively in the state or federal courts located in Milwaukee County, Wisconsin, and you consent to
            personal jurisdiction and venue in those courts.
          </p>
        </Section>

        <Section title="Changes to these Terms">
          <p>
            We may update these Terms from time to time. When we do, we will change the "Last updated" date at the
            top of this page. Continued use of the Site after an update constitutes acceptance of the revised Terms.
          </p>
        </Section>

        <Section title="Contact">
          <p>
            Questions about these Terms? Email{" "}
            <a className="text-[hsl(var(--accent))] underline" href="mailto:contact@shobhawithshubhra.com">
              contact@shobhawithshubhra.com
            </a>.
          </p>
        </Section>

        <div className="mt-16 text-sm">
          <Link to="/" className="text-[hsl(var(--accent))] underline">← Back to home</Link>
        </div>
      </section>
    </div>
  );
}
